
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGuestIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.871 18.267c9.076 0 16.434 7.358 16.434 16.434 0 6.13-3.357 11.474-8.331 14.299A26.64 26.64 0 0 1 47.66 59.052a1.7 1.7 0 1 1-2.781 1.955 23.24 23.24 0 0 0-38.023.002 1.7 1.7 0 1 1-2.78-1.956 26.64 26.64 0 0 1 13.689-10.054c-4.974-2.825-8.33-8.17-8.33-14.298 0-9.076 7.359-16.434 16.435-16.434m0 3.4c-7.198 0-13.034 5.836-13.034 13.034 0 7.186 5.815 13.013 12.996 13.033h.071c7.183-.018 13.001-5.846 13.001-13.033 0-7.198-5.836-13.034-13.034-13.034",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61 58a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-12.56a13.2 13.2 0 0 1 9.266 3.732c.235.227.387.515.445.82.059.303.025.623-.109.918a1.57 1.57 0 0 1-.627.7 1.65 1.65 0 0 1-.944.229 1.62 1.62 0 0 1-1.127-.475 9.84 9.84 0 0 0-6.906-2.816 9.84 9.84 0 0 0-6.904 2.815 1.62 1.62 0 0 1-1.134.459c-.41 0-.82-.153-1.133-.458a1.54 1.54 0 0 1-.001-2.193 13.2 13.2 0 0 1 9.173-3.731",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.998 38c5.446.014 10.668 2.136 14.532 5.907.3.293.47.69.47 1.106 0 .415-.17.813-.47 1.105-.303.295-.715.46-1.145.457a1.62 1.62 0 0 1-1.141-.457C69.86 42.8 65.43 41.14 60.998 41.14c-4.431 0-8.862 1.66-12.245 4.979-.316.31-.73.464-1.143.464s-.827-.154-1.142-.464a1.546 1.546 0 0 1-.001-2.212c3.864-3.77 9.086-5.893 14.53-5.907",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"80\" height=\"80\" viewBox=\"0 0 80 80\" fill=\"none\"><path d=\"M25.871 18.267c9.076 0 16.434 7.358 16.434 16.434 0 6.13-3.357 11.474-8.331 14.299A26.64 26.64 0 0 1 47.66 59.052a1.7 1.7 0 1 1-2.781 1.955 23.24 23.24 0 0 0-38.023.002 1.7 1.7 0 1 1-2.78-1.956 26.64 26.64 0 0 1 13.689-10.054c-4.974-2.825-8.33-8.17-8.33-14.298 0-9.076 7.359-16.434 16.435-16.434m0 3.4c-7.198 0-13.034 5.836-13.034 13.034 0 7.186 5.815 13.013 12.996 13.033h.071c7.183-.018 13.001-5.846 13.001-13.033 0-7.198-5.836-13.034-13.034-13.034\" fill=\"#000\"/><path d=\"M61 58a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-12.56a13.2 13.2 0 0 1 9.266 3.732c.235.227.387.515.445.82.059.303.025.623-.109.918a1.57 1.57 0 0 1-.627.7 1.65 1.65 0 0 1-.944.229 1.62 1.62 0 0 1-1.127-.475 9.84 9.84 0 0 0-6.906-2.816 9.84 9.84 0 0 0-6.904 2.815 1.62 1.62 0 0 1-1.134.459c-.41 0-.82-.153-1.133-.458a1.54 1.54 0 0 1-.001-2.193 13.2 13.2 0 0 1 9.173-3.731\" fill=\"var(--theme-primary, #810ea9)\"/><path d=\"M60.998 38c5.446.014 10.668 2.136 14.532 5.907.3.293.47.69.47 1.106 0 .415-.17.813-.47 1.105-.303.295-.715.46-1.145.457a1.62 1.62 0 0 1-1.141-.457C69.86 42.8 65.43 41.14 60.998 41.14c-4.431 0-8.862 1.66-12.245 4.979-.316.31-.73.464-1.143.464s-.827-.154-1.142-.464a1.546 1.546 0 0 1-.001-2.212c3.864-3.77 9.086-5.893 14.53-5.907\" fill=\"var(--theme-primary, #810ea9)\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/guest-icon.4d10f5a5ea2d7e7d38176f94266fa3ee.svg"),
        {
          React: SvgGuestIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      